import { StyleValueExtractionMethod } from "@iventis/domain-model/model/styleValueExtractionMethod";
import { Units } from "@iventis/domain-model/model/units";
import { ZoomableValueExtractionMethod } from "@iventis/domain-model/model/zoomableValueExtractionMethod";
import { ZoomValue } from "@iventis/domain-model/model/zoomValue";
import { PredefinedZoomLevels } from "../bridge/constants";

/** Creates a default style value which is zoomable */
export function createDefaultStyleZoomableValue(zoomLevelValues: { city: number; street: number; max: number }) {
    return {
        extractionMethod: StyleValueExtractionMethod.Static,
        dataFieldId: undefined,
        staticValue: {
            extractionMethod: ZoomableValueExtractionMethod.Continuous,
            staticValue: zoomLevelValues.max,
            mappedZoomValues: {
                [PredefinedZoomLevels.max]: { value: zoomLevelValues.max, hidden: zoomLevelValues.max === 0 },
                [PredefinedZoomLevels.street]: { value: zoomLevelValues.street, hidden: zoomLevelValues.street === 0 },
                [PredefinedZoomLevels.city]: { value: zoomLevelValues.city, hidden: zoomLevelValues.city === 0 },
                [PredefinedZoomLevels.country]: { value: 0, hidden: true },
                [PredefinedZoomLevels.world]: { value: 0, hidden: true },
            },
            unitType: Units.None,
        },
        mappedValues: undefined,
        multiValues: [],
        mappedPropertyListItemIds: [],
    };
}

/** Creates a Zoomable value given a key value pair object of the zoom level to the value it represents */
export function createCustomStyleZoomableValue(zoomLevelValues: Record<number, number>) {
    if (Object.keys(zoomLevelValues ?? {}).length < 1) {
        throw new Error("Need one or more value to create a custom style zoomable value");
    }

    const highestValue = Math.max(...Object.values(zoomLevelValues));

    const mappedZoomValues: Record<number, ZoomValue<number>> = {};

    for (const [zoomLevelValue, value] of Object.entries(zoomLevelValues)) {
        mappedZoomValues[zoomLevelValue] = { value, hidden: value === 0 };
    }

    return {
        extractionMethod: StyleValueExtractionMethod.Static,
        dataFieldId: undefined,
        staticValue: {
            extractionMethod: ZoomableValueExtractionMethod.Continuous,
            staticValue: highestValue,
            mappedZoomValues,
            unitType: Units.None,
        },
        mappedValues: undefined,
        multiValues: [],
        mappedPropertyListItemIds: [],
    };
}
